export const sectionImgs = {
  "00/dots": require("@/assets/img/prices/00/dots.svg"),
  "00/1900": require("@/assets/img/prices/00/1900.png"),
  "00/1904": require("@/assets/img/prices/00/1904.png"),
  "00/cerveza": require("@/assets/img/prices/00/cerveza.png"),
  "00/corona": require("@/assets/img/prices/00/corona.png"),

  "01/dots": require("@/assets/img/prices/01/dots.svg"),
  "01/1953": require("@/assets/img/prices/01/1953.png"),
  "01/1954": require("@/assets/img/prices/01/1954.png"),
  "01/1960": require("@/assets/img/prices/01/1960.png"),
  "01/cerveza": require("@/assets/img/prices/01/cerveza.png"),
  "01/cerveza2": require("@/assets/img/prices/01/cerveza2.png"),

  "02/dots": require("@/assets/img/prices/02/dots.svg"),
  "02/1968": require("@/assets/img/prices/02/1968.png"),
  "02/1986": require("@/assets/img/prices/02/1986.png"),
  "02/cerveza": require("@/assets/img/prices/02/cerveza.png"),
  "02/bruselas": require("@/assets/img/prices/02/bruselas.png"),

  "03/dots": require("@/assets/img/prices/03/dots.svg"),
  "03/1996": require("@/assets/img/prices/03/1996.png"),
  "03/bruselas": require("@/assets/img/prices/02/bruselas.png"),
};
